import { lazy } from "react";

import { redirect } from "react-router-dom";

import { SolicitudesLayout } from "../layouts/SolicitudesLayout";
import RutaProtegida from "@components/RutaProtegida.tsx";
import WhiteZone from "@components/WhiteZone";

const Solicitudes = lazy(() => import("@features/Solicitudes/pages/Solicitudes"));

export const solicitudesRoutes = {
    element: <RutaProtegida />,
    children: [
        {
            Component: SolicitudesLayout,
            path: "/solicitudes",
            errorElement: <WhiteZone error />,
            children: [
                {
                    index: true,
                    Component: Solicitudes,
                    loader: ({ request }) => {
                        const url = new URL(request.url);
                        if (/^\/(?:solicitudes|admin)\/$/.test(url.pathname)) {
                            return redirect(url.pathname.replace(/\/+$/, ""));
                        }
                    },
                },
            ],
        },
    ],
};
